module.exports = __webpack_public_path__ + "static/media/arrow-down.727bd16b.svg";